class ScrollBehavior {
    public static toTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export default ScrollBehavior;
